export default function ({ store, redirect, app }) {
  if (!store.state.auth.loggedIn && app.getRouteBaseName() !== 'profile') {
    return redirect(app.localePath('/auth/login'))
  }
}
